import NoImage from '../../../apps/web/public/images/Common/noImage.svg';

export const getFirstImage = (images: Array<{ target: string }>): string => {
  if (Array.isArray(images) && images.length > 0) return images[0].target;

  return NoImage;
};
